module.exports = __webpack_public_path__ + "static/media/tick.36a6b2c7.svg";